import { render, staticRenderFns } from "./Logic_Match.vue?vue&type=template&id=87af4256&scoped=true"
import script from "./Logic_Match.vue?vue&type=script&lang=js"
export * from "./Logic_Match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87af4256",
  null
  
)

export default component.exports